import React, { useState } from "react";
import { Link } from 'react-router-dom';
import Typist from "react-typist";
import IconButton from '@material-ui/core/IconButton';
import ExpandMoreOutlinedIcon from '@material-ui/icons/ExpandMoreOutlined';
import { scroller } from 'react-scroll';
import Configs from "../../Assets/editable-stuff/configurations.json";
import Seo from "../Seo";

const scrollFunc = (e) => {
  scroller.scrollTo(e, {
    duration: 1400,
    delay: 0,
    offset: 25,
    smooth: 'easeInOutQuart'
  })
}

const ITHeader = () => {
  const icons = Configs.icons;

  const [hoverstatus, setHoverstatus] = useState([
    "socialicons",
    "socialicons",
    "socialicons",
    "socialicons",
    "socialicons"
  ]);

  const toggleHover = data => {
    const newhoverStatus = [...hoverstatus];
    if (data.event === "enter") {
      newhoverStatus[data.icon.id] = "socialiconshover";
      return setHoverstatus(newhoverStatus);
    } else if (data.event === "leave") {
      newhoverStatus[data.icon.id] = "socialicons";
      return setHoverstatus(newhoverStatus);
    }
  };

  const itFeatures = [
    { title: "Fast Service", desc: "Same-day repairs available", icon: "⚡" },
    { title: "Expert Techs", desc: "Certified professionals", icon: "🛠️" },
    { title: "Fair Pricing", desc: "No hidden fees", icon: "💰" }
  ];
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Service",
    name: "IT Support and Computer Repair",
    serviceType: "IT support, computer repair, remote support, and network optimization",
    provider: {
      "@type": "LocalBusiness",
      name: "NeedForGeeks",
      url: "https://www.needforgeeks.com",
    },
    areaServed: {
      "@type": "City",
      name: "New York",
    },
    url: "https://www.needforgeeks.com/it",
    description:
      "NeedForGeeks provides IT support, computer repair, Wi-Fi optimization, virus removal, and cloud migration services in New York.",
  };

  return (
    <div>
      <Seo
        title="IT Support & Computer Repair in New York | NeedForGeeks"
        description="IT support in New York from NeedForGeeks: virus removal, Wi-Fi optimization, cloud migration, system upgrades, and remote help for homes and businesses."
        path="/it"
        keywords="IT support New York, computer repair New York, virus removal New York, Wi-Fi optimization New York, cloud migration New York"
        structuredData={structuredData}
      />

      <div className="hero-modern hero-it">
        {/* Left Content Side */}
        <div className="hero-content-side">
          <div className="hero-badge">
            <span className="badge-dot"></span>
            IT Support & Repairs
          </div>

          <h1 className="hero-title-modern">Information Technology</h1>

          <div className="hero-typing">
            <Typist
              cursor={{ show: true, blink: true, element: '|' }}
              avgTypingDelay={40}
            >
              Expert tech support when you need it
            </Typist>
          </div>

          <p className="hero-description">
            From virus removal to hardware upgrades, our certified technicians solve your tech problems fast. On-site and remote support available.
          </p>

          <div className="hero-social-row">
            {icons.map(icon => (
              <a
                key={icon.id}
                target="_blank"
                rel="noopener noreferrer"
                href={icon.url}
                aria-label={`My ${icon.image.split("-")[1]}`}
                className="hero-social-link"
              >
                <i
                  className={`fab ${icon.image} fa-lg ${hoverstatus[icon.id]}`}
                  onMouseOver={() => toggleHover({ icon, event: "enter" })}
                  onMouseOut={() => toggleHover({ icon, event: "leave" })}
                />
              </a>
            ))}
          </div>
        </div>

        {/* Right Side */}
        <div className="hero-services-side">
          <div className="automation-features-grid">
            {itFeatures.map((feature, index) => (
              <div
                key={index}
                className="automation-feature-card"
                style={{ animationDelay: `${index * 0.15}s` }}
              >
                <span className="feature-icon-large">{feature.icon}</span>
                <h4 className="feature-title">{feature.title}</h4>
                <p className="feature-desc">{feature.desc}</p>
              </div>
            ))}
          </div>

          <div className="hero-nav-cards">
            <Link to="/" className="nav-card-mini">
              <span>← Home</span>
            </Link>
            <Link to="/web-app" className="nav-card-mini">
              <span>Web & Apps →</span>
            </Link>
            <Link to="/automation" className="nav-card-mini">
              <span>Automation →</span>
            </Link>
          </div>
        </div>

        {/* Scroll Indicator */}
        <IconButton
          onClick={() => scrollFunc("services-section")}
          className="scroll-indicator"
        >
          <ExpandMoreOutlinedIcon style={{ color: "white", fontSize: "32px" }} />
        </IconButton>

        {/* Background Elements */}
        <div className="hero-bg-gradient"></div>
        <div className="hero-bg-orb hero-bg-orb-1"></div>
        <div className="hero-bg-orb hero-bg-orb-2"></div>
      </div>
    </div>
  );
};

export default ITHeader;
